<!-- app-content-header start -->
<ng-container *ngIf="contentHeader">
  <div class="content-header row">
    <div class="content-header-left col-12 mb-2">
      <div class="row breadcrumbs-top">
        <div class="col-12">
          <h2 class="content-header-title mb-0">{{ contentHeader.headerTitle | translate }}</h2>
          <app-breadcrumb *ngIf="contentHeader?.breadcrumb?.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- app-content-header end -->
